import React, { useEffect, useMemo, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { Modal, Button } from "react-bootstrap";
import CompletarDatosFactura from './CompletarDatosFactura';
import { getSpaPathPrefix } from '../../../resources/Constants';

function ListadoFacturas() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);

    const history = useHistory();
    const location = useLocation();

    /** `filtro` en query (?filtro=vencidas desde el home) para acotar vista y rangos de fecha. */
    const [filtroUrlActivo, setFiltroUrlActivo] = useState(null);

    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [busquedaDocumento, setBusquedaDocumento] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [tipoFacturaFiltro, setTipoFacturaFiltro] = useState('');

    // Modal Recibo de Caja
    const [showModalRecibo, setShowModalRecibo] = useState(false);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
    const [valorRecibo, setValorRecibo] = useState('');
    const [medioPago, setMedioPago] = useState('10');
    const [fechaPago, setFechaPago] = useState(new Date().toISOString().split('T')[0]);
    const [observacionesRecibo, setObservacionesRecibo] = useState('');

    // Modal Nota Crédito Electrónica
    const [showModalNotaCredito, setShowModalNotaCredito] = useState(false);
    const [prefijos, setPrefijos] = useState([]);
    const [prefijoSeleccionado, setPrefijoSeleccionado] = useState('');
    const [numeroNotaCredito, setNumeroNotaCredito] = useState('');
    const [fechaNotaCredito, setFechaNotaCredito] = useState(new Date().toISOString().split('T')[0]);
    const [tipoNotaCredito, setTipoNotaCredito] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCredito, setValorNotaCredito] = useState('');
    const [motivoNotaCredito, setMotivoNotaCredito] = useState('');

    // Modal Ver Recibos
    const [showModalRecibos, setShowModalRecibos] = useState(false);
    const [recibosFactura, setRecibosFactura] = useState([]);

    // Modal Éxito Recibo
    const [showModalExitoRecibo, setShowModalExitoRecibo] = useState(false);
    const [reciboGuardado, setReciboGuardado] = useState(null);

    // Modal Nota Crédito No Electrónica
    const [showModalNotaCreditoNE, setShowModalNotaCreditoNE] = useState(false);
    const [tipoNotaCreditoNE, setTipoNotaCreditoNE] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCreditoNE, setValorNotaCreditoNE] = useState('');
    const [motivoNotaCreditoNE, setMotivoNotaCreditoNE] = useState('');
    const [fechaNotaCreditoNE, setFechaNotaCreditoNE] = useState(new Date().toISOString().split('T')[0]);
    const [consecutivoNCNE, setConsecutivoNCNE] = useState(null); // Datos del consecutivo
    const [loadingNCNE, setLoadingNCNE] = useState(false);

    // Dropdown Nueva Factura
    const [showDropdownFactura, setShowDropdownFactura] = useState(false);

    // Dropdown acciones barra superior
    const [showDropdownAcciones, setShowDropdownAcciones] = useState(false);

    // Selección de facturas
    const [facturaSeleccionadaId, setFacturaSeleccionadaId] = useState(null);

    // Modal Completar Datos Factura
    const [showModalCompletarDatos, setShowModalCompletarDatos] = useState(false);
    const [facturaCompletarId, setFacturaCompletarId] = useState(null);

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;

    // Modal Debug - Para mostrar respuestas de DIAN
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'success', 'error'

    // 🔒 Función helper para validar permisos
    const tienePermiso = (permiso) => {
        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        return userdata.up && userdata.up.includes(permiso);
    };

    // --- NUEVA LÓGICA DE ACCIONES Y STATS ---
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [facturaAccion, setFacturaAccion] = useState(null);

    const handleAbrirAcciones = (factura) => {
        setFacturaAccion(factura);
        setShowModalAcciones(true);
    };

    const esFacturaContado = (f) => (f?.tipo_pago || '').toLowerCase() === 'contado';

    /** Misma regla que la tabla (tipo o estados 4/5 no electrónica). */
    const esFacturaNoElectronica = (f) =>
        f.tipo_factura === 'no_electronica' || [4, 5].includes(parseInt(f.estado, 10));

    const getValorTotalNum = (f) => parseFloat(f?.valor_total || 0) || 0;

    /** Saldo pendiente; si no viene, se asume el total. El string "0" se interpreta como 0, no como falsy que dispare || total. */
    const getSaldoPendienteNum = (f) => {
        const raw = f?.valor_pendiente;
        if (raw === null || raw === undefined || raw === '') return getValorTotalNum(f);
        const p = parseFloat(raw);
        return Number.isFinite(p) ? p : getValorTotalNum(f);
    };

    /** NC tipo total: contado = valor total de la factura (anulación completa); crédito = saldo pendiente. */
    const getImporteNcTipoTotal = (f) =>
        esFacturaContado(f) ? getValorTotalNum(f) : getSaldoPendienteNum(f);

    const facturasParaVista = useMemo(() => {
        if (filtroUrlActivo !== 'vencidas') return facturas;
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        return facturas.filter((f) => {
            if (!f.fecha_vence) return false;
            const fv = new Date(f.fecha_vence);
            if (Number.isNaN(fv.getTime())) return false;
            fv.setHours(0, 0, 0, 0);
            return fv < hoy;
        });
    }, [facturas, filtroUrlActivo]);

    const totales = {
        total: facturasParaVista.filter(f => f.estado !== 3).reduce((sum, f) => sum + parseFloat(f.valor_total || 0), 0),
        recaudado: facturasParaVista.filter(f => f.estado !== 3).reduce((sum, f) => sum + (parseFloat(f.valor_total || 0) - parseFloat(f.valor_pendiente || 0)), 0),
        pendiente: facturasParaVista.filter(f => f.estado !== 3).reduce((sum, f) => sum + parseFloat(f.valor_pendiente || 0), 0),
        anuladas: facturasParaVista.filter(f => f.estado === 3).length,
        conteo: facturasParaVista.length
    };

    useEffect(() => {
        // Validar permisos primero
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Verificar si tiene permiso para ver listado de facturas
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_facturas');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const hoy = new Date();
        const diaSemana = hoy.getDay();
        const inicioSemana = new Date(hoy);
        inicioSemana.setDate(hoy.getDate() - diaSemana);
        const finSemana = new Date(inicioSemana);
        finSemana.setDate(inicioSemana.getDate() + 6);
        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

    }, []);

    /** HashRouter: query en `#/ruta?filtro=...`; si no, `window.location.search` (BrowserRouter). */
    const queryStringDesdeUrl = () => {
        const hash = window.location.hash || '';
        const i = hash.indexOf('?');
        if (i !== -1) return hash.slice(i);
        const s = window.location.search;
        return s && s.length > 1 ? s : '';
    };

    useEffect(() => {
        if (!hasPermission) return;
        const filtro = new URLSearchParams(queryStringDesdeUrl()).get('filtro');
        const fin = new Date();
        const finStr = fin.toISOString().split('T')[0];

        if (filtro === 'vencidas') {
            const inicio = new Date();
            inicio.setFullYear(inicio.getFullYear() - 5);
            setFechaInicio(inicio.toISOString().split('T')[0]);
            setFechaFin(finStr);
            setEstadoFiltro('pendientes_pago');
            setFiltroUrlActivo('vencidas');
        } else if (filtro === 'pendientes') {
            const inicio = new Date();
            inicio.setFullYear(inicio.getFullYear() - 2);
            setFechaInicio(inicio.toISOString().split('T')[0]);
            setFechaFin(finStr);
            setEstadoFiltro('pendientes_envio');
            setFiltroUrlActivo('pendientes');
        } else {
            setFiltroUrlActivo(null);
        }
    }, [hasPermission, location]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarFacturas();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, tipoFacturaFiltro, numeroFactura]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarFacturas();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaPaciente, busquedaDocumento, numeroFactura]);

    const cargarFacturas = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);
        if (busquedaDocumento) params.append('busqueda_documento', busquedaDocumento);
        if (numeroFactura) params.append('numero_factura', numeroFactura);
        if (tipoFacturaFiltro) params.append('tipo_factura', tipoFacturaFiltro);

        // Contado / Crédito: solo tipo_pago (FacturaController excluye estado 3 — anuladas)
        if (estadoFiltro === 'contado') {
            params.append('tipo_pago', 'contado');
        } else if (estadoFiltro === 'credito') {
            params.append('tipo_pago', 'credito');
        } else if (estadoFiltro !== '') {
            params.append('estado', estadoFiltro);
        }

        axios.get('/facturas?' + params.toString())
            .then(response => {
                if (response.status === 200) {
                    setFacturas(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const getNombrePaciente = (pacienteId) => {
        const paciente = pacientes.find(p => p.id === pacienteId);
        if (paciente) {
            return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        }
        return 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id == usuarioId); // Usar == en lugar de === para comparación flexible
        return usuario ? usuario.name : 'N/A';
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            case 7: return 'Borrador RIPS';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-warning';
            case 3: return 'badge badge-outline-danger';
            case 4: return 'badge badge-outline-success';
            case 5: return 'badge badge-outline-warning';
            case 6: return 'badge badge-outline-danger';
            case 7: return 'badge badge-outline-info';
            default: return 'badge badge-outline-secondary';
        }
    };

    // Badges "pill" suaves para un look premium (especialmente Borrador RIPS).
    const getEstadoBadgeStyle = (estado) => {
        switch (estado) {
            case 7: // Borrador RIPS
                return { background: 'rgba(23, 162, 184, 0.08)', color: '#17a2b8', border: '1px solid rgba(23, 162, 184, 0.22)', borderRadius: '10px' };
            case 1: // Cobrada
            case 4:
                return { background: 'rgba(40, 167, 69, 0.08)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)', borderRadius: '10px' };
            case 2: // Por Cobrar
            case 5:
                return { background: 'rgba(250, 173, 20, 0.10)', color: '#faad14', border: '1px solid rgba(250, 173, 20, 0.22)', borderRadius: '10px' };
            case 3: // Anulada
            case 6: // Error DIAN
                return { background: 'rgba(220, 53, 69, 0.08)', color: '#dc3545', border: '1px solid rgba(220, 53, 69, 0.22)', borderRadius: '10px' };
            case 0: // Generada
            default:
                return { background: 'rgba(108, 117, 125, 0.08)', color: '#6c757d', border: '1px solid rgba(108, 117, 125, 0.22)', borderRadius: '10px' };
        }
    };

    /** Mensajes de API para el cliente: quita códigos numéricos de estado internos (p. ej. "estado 3", "estado_actual: 7"). */
    const mensajeClienteSinCodigoEstado = (msg) => {
        if (msg == null) return '';
        let s = String(msg);
        s = s.replace(/\bestado_actual\s*[:=]\s*\d+/gi, '');
        s = s.replace(/\bestado\s*[:=]\s*\d+/gi, '');
        s = s.replace(/\bestado\s+\d+\b/gi, '');
        s = s.replace(/\ben estado\s+\d+\b/gi, 'en el estado actual');
        s = s.replace(/\(\s*estado\s*\d+\s*\)/gi, '');
        s = s.replace(/[,\s]+([,.])/g, '$1');
        s = s.replace(/\s{2,}/g, ' ').replace(/^[\s,;:.-]+|[\s,;:.-]+$/g, '').trim();
        return s || 'Operación no completada. Intente de nuevo o contacte soporte.';
    };

    const abrirModalRecibo = (factura) => {
        setFacturaSeleccionada(factura);
        setValorRecibo(0);
        setMedioPago('10');
        setFechaPago(new Date().toISOString().split('T')[0]);
        setObservacionesRecibo('');
        setShowModalRecibo(true);
    };

    const guardarRecibo = async () => {
        const valorPendiente = facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total;

        if (!valorRecibo || parseFloat(valorRecibo) <= 0) {
            alert('Ingrese un valor válido');
            return;
        }

        if (parseFloat(valorRecibo) > parseFloat(valorPendiente)) {
            alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(parseFloat(valorPendiente)).toLocaleString('es-CO')}`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const reciboData = {
            factura_id: facturaSeleccionada.id,
            valor_recibido: parseFloat(valorRecibo),
            medio_pago: medioPago,
            fecha_pago: fechaPago,
            observaciones: observacionesRecibo
        };

        try {
            const response = await axios.post('/recibo-caja', reciboData);
            if (response.status === 200 || response.status === 201) {
                setShowModalRecibo(false);
                setReciboGuardado(response.data);
                setShowModalExitoRecibo(true);
                cargarFacturas();
            }
        } catch (error) {
            alert('Error al registrar el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirInformacionFactura = (facturaId) => {
        const prefix = getSpaPathPrefix();
        const url = `${window.location.origin}${prefix}/#/informacion-factura/${facturaId}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    /**
     * Anulación directa (sin modal de nota crédito): borrador / error DIAN / borrador RIPS.
     */
    const anularFacturaSimple = async (factura) => {
        const est = parseInt(factura.estado, 10);
        let mensaje = '¿Está seguro de anular esta factura?';
        if (est === 6) mensaje = '¿Anular esta factura en error DIAN?';
        if (est === 7) mensaje = '¿Anular este borrador RIPS?';
        if (est === 0) mensaje = '¿Anular esta factura generada?';

        if (!window.confirm(mensaje)) return;

        try {
            const response = await axios.put(`/factura/${factura.id}/estado`, { estado: 3 });
            if (response.status === 200 || response.data?.success) {
                alert('La factura fue anulada correctamente.');
                cargarFacturas();
            }
        } catch (error) {
            const detalle = mensajeClienteSinCodigoEstado(
                error.response?.data?.message || error.response?.data?.error || error.message
            );
            alert('No se pudo anular la factura. ' + (detalle ? detalle : 'Intente de nuevo o contacte soporte.'));
        }
    };

    /**
     * Desde el menú de acciones: NC electrónica, NC no electrónica o anulación simple según estado/tipo.
     */
    const abrirFlujoAnularFactura = (factura) => {
        const est = parseInt(factura.estado, 10);
        if ([0, 6, 7].includes(est)) {
            anularFacturaSimple(factura);
            return;
        }
        if (esFacturaNoElectronica(factura)) {
            abrirModalNotaCreditoNoElectronica(factura);
            return;
        }
        abrirModalNotaCredito(factura);
    };

    const abrirModalNotaCredito = async (factura) => {
        setFacturaSeleccionada(factura);
        setPrefijoSeleccionado('');
        setNumeroNotaCredito('');
        setTipoNotaCredito('total');
        setValorNotaCredito(getImporteNcTipoTotal(factura));
        setMotivoNotaCredito('');

        // Cargar prefijos filtrados por tipo NC y usuario de la factura
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get('/parametros-fev?uid=' + userdata.user_id);
            if (response.status === 200) {
                const prefijosFiltrados = response.data.filter(param =>
                    param.tipo === 'Nota Credito' &&
                    param.users_id == factura.users_id &&
                    param.estado == 1
                );
                setPrefijos(prefijosFiltrados);
            }
        } catch (error) {
            console.log('Error cargando prefijos: ' + error);
        }

        setShowModalNotaCredito(true);
    };

    const handlePrefijoChange = (e) => {
        const prefijoId = e.target.value;
        setPrefijoSeleccionado(prefijoId);

        if (prefijoId) {
            const prefijo = prefijos.find(p => p.id == prefijoId);
            if (prefijo) {
                setNumeroNotaCredito(prefijo.numero_factura);
            }
        } else {
            setNumeroNotaCredito('');
        }
    };

    const abrirCompletarDatos = (facturaId) => {
        setFacturaCompletarId(facturaId);
        setShowModalCompletarDatos(true);
    };

    const handleCompletarDatosSuccess = () => {
        setShowModalCompletarDatos(false);
        setFacturaCompletarId(null);
        cargarFacturas(); // Recargar el listado
    };

    const generarNotaCredito = async () => {
        if (!prefijoSeleccionado) {
            alert('Seleccione un prefijo');
            return;
        }

        if (!fechaNotaCredito) {
            alert('Seleccione una fecha');
            return;
        }

        if (!motivoNotaCredito.trim()) {
            alert('Ingrese el motivo de la nota crédito');
            return;
        }

        if (tipoNotaCredito === 'parcial' && esFacturaContado(facturaSeleccionada)) {
            alert('La nota crédito parcial aplica solo a facturas a crédito.');
            return;
        }

        // Validar valor si es parcial (solo crédito)
        if (tipoNotaCredito === 'parcial') {
            const valor = parseFloat(valorNotaCredito);
            const saldoPendiente = getSaldoPendienteNum(facturaSeleccionada);

            if (!valorNotaCredito || valor <= 0) {
                alert('Ingrese un valor válido para la nota crédito');
                return;
            }

            if (valor > saldoPendiente) {
                alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(saldoPendiente).toLocaleString('es-CO')}`);
                return;
            }
        }

        const mensajeConfirmacion = tipoNotaCredito === 'total'
            ? '¿Está seguro de generar una Nota Crédito TOTAL? Esta acción no se puede deshacer.'
            : `¿Está seguro de generar una Nota Crédito PARCIAL por $${Math.round(parseFloat(valorNotaCredito)).toLocaleString('es-CO')}? Esta acción no se puede deshacer.`;

        if (!window.confirm(mensajeConfirmacion)) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        const notaCreditoData = {
            factura_id: facturaSeleccionada.id,
            parametrosfev_id: prefijoSeleccionado,
            motivo: motivoNotaCredito,
            fecha_emision: fechaNotaCredito,
            tipo: tipoNotaCredito,
            valor: tipoNotaCredito === 'parcial' ? parseFloat(valorNotaCredito) : null
        };

        try {
            const response = await axios.post('/nota-credito/enviar-dian-directo', notaCreditoData);

            setShowModalNotaCredito(false);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: response.data.message,
                    uuid: response.data.uuid,
                    cufe: response.data.uuid,
                    numero_nc: response.data.numero_nc,
                    recibos_anulados: response.data.recibos_anulados,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            }

            cargarFacturas();
            setPrefijoSeleccionado('');
            setNumeroNotaCredito('');
            setFechaNotaCredito(new Date().toISOString().split('T')[0]);
            setTipoNotaCredito('total');
            setValorNotaCredito('');
            setMotivoNotaCredito('');

        } catch (error) {
            console.error('Error al generar nota crédito:', error);
            setShowModalNotaCredito(false);

            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                facturaId: facturaSeleccionada.id
            });
            setShowModalDebug(true);
        }
    };

    const verRecibos = async (factura) => {
        setFacturaSeleccionada(factura);

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get(`/recibos-caja/${factura.id}?uid=${userdata.user_id}`);
            if (response.status === 200) {
                setRecibosFactura(response.data);
                setShowModalRecibos(true);
            }
        } catch (error) {
            alert('Error al cargar los recibos: ' + (error.response?.data?.message || error.message));
        }
    };

    const getMedioPagoTexto = (codigo) => {
        const mediosPago = {
            '10': 'Efectivo',
            '42': 'Consignación bancaria',
            '1': 'Instrumento no definido',
            '20': 'Cheque',
            '30': 'Transferencia Crédito',
            '31': 'Transferencia Débito',
            '45': 'Transferencia Crédito Bancario',
            '47': 'Transferencia Débito Bancaria',
            '48': 'Tarjeta Crédito',
            '49': 'Tarjeta Débito',
            'ZZZ': 'Acuerdo mutuo'
        };
        return mediosPago[codigo] || codigo;
    };

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const anularRecibo = async (reciboId) => {
        if (!window.confirm('¿Está seguro de anular este recibo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        // Mantener el estado actual según el tipo de factura
        // Estado 2: Por Cobrar (Electrónica) - mantener en 2
        // Estado 5: Por Cobrar (No Electrónica) - mantener en 5
        const estadoDestino = facturaSeleccionada.estado === 5 ? 5 : 2;

        try {
            const response = await axios.put(`/recibo-caja/${reciboId}/anular?uid=${userdata.user_id}`,
                { estado_factura_destino: estadoDestino }
            );
            if (response.status === 200) {
                alert('El recibo fue anulado correctamente.');
                verRecibos(facturaSeleccionada);
                cargarFacturas();
            }
        } catch (error) {
            const detalle = mensajeClienteSinCodigoEstado(
                error.response?.data?.message || error.response?.data?.error || error.message
            );
            alert('No se pudo anular el recibo. ' + (detalle ? detalle : 'Intente de nuevo.'));
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const construirDireccionCompleta = (paciente) => {
        if (!paciente) return '';
        const partes = [];
        if (paciente.direccion) partes.push(paciente.direccion);
        if (paciente.zona) partes.push(paciente.zona);
        if (paciente.nombre_ciudad_residencia) partes.push(paciente.nombre_ciudad_residencia);
        if (paciente.nombre_departamento_residencia) partes.push(paciente.nombre_departamento_residencia);
        if (paciente.nombre_pais_residencia) partes.push(paciente.nombre_pais_residencia);
        return partes.join(', ') || paciente.direccion || '';
    };

    const obtenerNit = () => {
        if (client?.numero_documento) {
            return client.digito_verificacion
                ? `${client.numero_documento}-${client.digito_verificacion}`
                : client.numero_documento;
        }
        return '';
    };

    const vistaPreviaRecibo = async (recibo) => {
        let paciente = pacientes.find(p => p.id === facturaSeleccionada?.paciente_id);

        // Siempre cargar los datos completos del paciente para asegurar que tenemos todos los campos
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${facturaSeleccionada?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
                console.log('Paciente cargado:', paciente);
                console.log('Teléfono:', paciente.telefono);
                console.log('Celular:', paciente.celular);
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim() : getNombrePaciente(facturaSeleccionada?.paciente_id);

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // 🆕 BANNER: RECIBO DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBO DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del recibo en tabla
        const datosReciboHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">RECIBO #</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${recibo.numero_recibo}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA PAGO</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(recibo.fecha_pago)}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FORMA DE PAGO</td>
                        <td style="background-color: #ffffff; width: 19%; padding: 6px; border: 1px solid #dee2e6;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td colspan="5" style="background-color: #ffffff; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibo = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReciboHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit()}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Concepto</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px; background-color: #ffffff; font-size: 12px;">Abono a Factura N° ${facturaSeleccionada?.numero_factura || ''}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; background-color: #ffffff; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif; white-space: nowrap;">Total:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    ${recibo.observaciones ? `
                    <div style="margin-top: 20px;">
                        <h6 style="font-size: 14px; font-weight: bold;">Observaciones:</h6>
                        <p style="font-size: 12px;">${recibo.observaciones}</p>
                    </div>
                    ` : ''}

                    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px;">
                        <p style="color: #666; margin-bottom: 30px; font-size: 12px;">Recibí conforme el valor arriba mencionado</p>
                        <div style="margin-top: 50px;">
                            <div style="border-top: 1px solid #333; width: 200px; margin: 0 auto;"></div>
                            <p style="margin-top: 5px; color: #666; font-size: 12px;">Firma del Paciente</p>
                        </div>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibo de Caja N° ${recibo.numero_recibo}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibo}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const vistaPreviaRecibos = async () => {
        let paciente = pacientes.find(p => p.id === facturaSeleccionada?.paciente_id);

        // Siempre cargar los datos completos del paciente para asegurar que tenemos todos los campos
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${facturaSeleccionada?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
                console.log('Paciente cargado (recibos):', paciente);
                console.log('Teléfono:', paciente.telefono);
                console.log('Celular:', paciente.celular);
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim() : getNombrePaciente(facturaSeleccionada?.paciente_id);
        const totalRecibosActivos = recibosFactura.filter(r => r.estado !== 0).reduce((sum, r) => sum + parseFloat(r.valor_pago), 0);

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // 🆕 BANNER: RECIBOS DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBOS DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del reporte en tabla
        const datosReporteHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA REPORTE</td>
                        <td style="background-color: #ffffff; width: 35%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(new Date().toISOString())}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td style="background-color: #ffffff; width: 35%; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibos = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReporteHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit()}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">N° Recibo</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Fecha Pago</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Medio Pago</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: center; font-size: 12px;">Estado</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${recibosFactura.map((recibo, index) => `
                                <tr style="background-color: ${index % 2 === 0 ? '#f8f9fa' : '#ffffff'};">
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${recibo.numero_recibo}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${formatearFecha(recibo.fecha_pago)}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px; font-weight: bold;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; text-align: center; font-size: 12px;">
                                        <span style="padding: 4px 8px; border-radius: 3px; font-size: 11px; font-weight: bold; color: white; background: ${recibo.estado === 0 ? '#dc3545' : '#28a745'};">
                                            ${recibo.estado === 0 ? 'Anulado' : 'Activo'}
                                        </span>
                                    </td>
                                    <td style="border: 1px solid #dee2e6; padding: 8px; font-size: 12px;">${recibo.observaciones || '-'}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-weight: bold; white-space: nowrap;">Total Recibos Activos:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-family: monospace; font-weight: bold;">$${Math.round(totalRecibosActivos).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=900,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibos de Caja - Factura ${facturaSeleccionada?.numero_factura}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibos}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const enviarWhatsAppFactura = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        let celularPaciente = '';
        let nombrePaciente = '';

        try {
            // Get patient info
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${factura.paciente_id}`);
            if (response.data && response.data.length > 0) {
                const paciente = response.data[0];
                celularPaciente = paciente.celular || paciente.telefono;
                nombrePaciente = `${paciente.primer_nombre} ${paciente.primer_apellido}`;
            }
        } catch (error) {
            console.log('Error getting patient info:', error);
            // Fallback if we can't get fresh info (using data from list if available, though list might not have phone)
        }

        if (!celularPaciente) {
            alert('El paciente no tiene número de celular registrado.');
            return;
        }

        const msg = `Hola ${nombrePaciente}, adjunto la factura N° ${factura.numero_factura} por valor de $${Math.round(factura.valor_total).toLocaleString('es-CO')}.`;
        const url = `https://wa.me/57${celularPaciente}?text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
    };

    const getFacturaSeleccionada = () => {
        return facturasParaVista.find(f => f.id === facturaSeleccionadaId);
    };

    const handleSeleccionFactura = (facturaId) => {
        setFacturaSeleccionadaId(facturaSeleccionadaId === facturaId ? null : facturaId);
    };

    // Calcular facturas paginadas
    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const facturasPaginadas = facturasParaVista.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(facturasParaVista.length / registrosPorPagina);

    // Paginación compacta para no mostrar 1..50 cuando hay muchas páginas.
    // Regla:
    // - total <= 7: muestra todas
    // - si página actual está al inicio: muestra 1..4 ... last
    // - si está al final: muestra 1 ... last-3..last
    // - en medio: muestra 1 ... (current-1..current+1) ... last
    const getPaginationItems = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

        if (current <= 3) return [1, 2, 3, 4, null, total];
        if (current >= total - 2) return [1, null, total - 3, total - 2, total - 1, total];

        return [1, null, current - 1, current, current + 1, null, total];
    };

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        setFacturaSeleccionadaId(null); // Deseleccionar al cambiar de página
    };

    // Resetear a página 1 cuando cambien los filtros
    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, tipoFacturaFiltro, busquedaPaciente, busquedaDocumento, numeroFactura, filtroUrlActivo]);

    const reenviarFacturaDian = async (facturaId) => {
        if (!window.confirm('¿Está seguro de reintentar el envío de esta factura a la DIAN?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

        try {
            const response = await axios.post(`/factura/${facturaId}/enviar-dian`, {});

            console.log('Respuesta completa de enviar-dian:', response.data);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Factura enviada exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
                cargarFacturas();
            } else {
                // Cuando success = false, mostrar el error con toda la información
                console.log('Error de DIAN - response.data:', response.data);
                setDebugType('error');
                setDebugData({
                    message: response.data.message || 'Error al enviar a la DIAN',
                    response: response.data.response || response.data.error,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    fullError: response.data,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN (catch):', error);
            console.log('error.response?.data:', error.response?.data);
            console.log('error.response?.data completo:', JSON.stringify(error.response?.data, null, 2));

            // Construir debugData con toda la información disponible
            const errorData = {
                message: error.response?.data?.message || error.message || 'Error al enviar a la DIAN',
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                status_code: error.response?.status || error.response?.data?.status_code,
                fullError: error.response?.data || error,
                facturaId: facturaId
            };

            console.log('debugData que se va a mostrar:', errorData);

            setDebugType('error');
            setDebugData(errorData);
            setShowModalDebug(true);
        }
    };

    const verJsonPreview = async (facturaId) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        //  Ya NO necesitas config - el interceptor agrega el token autom�ticamente

        try {
            const response = await axios.get(`/factura/${facturaId}/json-dian?uid=${userdata.user_id}`);

            setDebugType('json');
            setDebugData({
                message: 'JSON que se enviará a la DIAN',
                subtitle: `Factura ID: ${facturaId}`,
                json: response.data
            });
            setShowModalDebug(true);
        } catch (error) {
            console.error('Error al generar JSON:', error);
            alert('Error al generar JSON: ' + (error.response?.data?.message || error.message));
        }
    };

    // ==========================================
    // Lógica para Nota Crédito No Electrónica
    // ==========================================

    const abrirModalNotaCreditoNoElectronica = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        setFacturaSeleccionada(factura);
        setLoadingNCNE(true);

        try {
            const response = await axios.get('/consecutivo-nc-no-electronica?uid=' + userdata.user_id);
            if (response.data) {
                setConsecutivoNCNE(response.data);

                // Inicializar formulario: contado → valor total; crédito → saldo pendiente
                setTipoNotaCreditoNE('total');
                setValorNotaCreditoNE(getImporteNcTipoTotal(factura));
                setMotivoNotaCreditoNE('');
                setFechaNotaCreditoNE(new Date().toISOString().split('T')[0]);

                setShowModalNotaCreditoNE(true);
            } else {
                alert('No se ha configurado un consecutivo para Notas Crédito No Electrónicas. Vaya a Configuración > Administrador Contable.');
            }
        } catch (error) {
            console.error(error);
            alert('Error al obtener consecutivo de Notas Crédito.');
        } finally {
            setLoadingNCNE(false);
        }
    };

    const generarNotaCreditoNE = async (e) => {
        e.preventDefault();

        if (!facturaSeleccionada || !consecutivoNCNE) return;

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const total = getValorTotalNum(facturaSeleccionada);
        const pend = getSaldoPendienteNum(facturaSeleccionada);
        const contado = esFacturaContado(facturaSeleccionada);
        const valorAplicar = parseFloat(valorNotaCreditoNE);

        if (tipoNotaCreditoNE === 'parcial' && contado) {
            alert('La nota crédito parcial aplica solo a facturas a crédito.');
            return;
        }

        const topeMax = contado ? total : pend;

        // Validaciones
        if (valorAplicar <= 0) {
            alert("El valor de la nota crédito debe ser mayor a 0.");
            return;
        }

        if (valorAplicar > topeMax + 100) {
            const etiqueta = contado ? 'el valor total de la factura' : 'el saldo pendiente';
            alert(`El valor de la nota crédito ($${valorAplicar.toLocaleString()}) no puede superar ${etiqueta} ($${Math.round(topeMax).toLocaleString('es-CO')}).`);
            return;
        }

        if (!motivoNotaCreditoNE.trim()) {
            alert("Debe ingresar un motivo para la nota crédito.");
            return;
        }

        if (!window.confirm(`¿Está seguro de generar una Nota Crédito por valor de $${valorAplicar.toLocaleString()}? Esta acción afectará el saldo y el consecutivo.`)) {
            return;
        }

        const data = {
            factura_id: facturaSeleccionada.id,
            valor: valorAplicar,
            motivo: motivoNotaCreditoNE,
            fecha: fechaNotaCreditoNE,
            consecutivo_id: consecutivoNCNE.id,
            tipo_nota: tipoNotaCreditoNE // 'total' o 'parcial'
        };

        setLoadingNCNE(true);

        try {
            const response = await axios.post('/nota-credito-no-electronica?uid=' + userdata.user_id, data);

            if (response.data.success) {
                alert('Nota Crédito generada exitosamente: ' + response.data.numero_nota);
                setShowModalNotaCreditoNE(false);
                cargarFacturas(); // Recargar lista
            } else {
                alert(
                    'No se pudo generar la nota crédito. ' +
                    mensajeClienteSinCodigoEstado(response.data?.message || '')
                );
            }

        } catch (error) {
            console.error(error);
            alert(
                'No se pudo generar la Nota Crédito. ' +
                mensajeClienteSinCodigoEstado(error.response?.data?.message || error.message)
            );
        } finally {
            setLoadingNCNE(false);
        }
    };

    if (loggedIn) {
        return (
            <div className="wrapper" style={{ fontSize: '13px' }}>
                <style>{`
                    .summary-card { background: #fff; padding: 1.25rem; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); border: none; transition: transform 0.2s; height: 100%; }
                    .summary-card:hover { transform: translateY(-5px); }
                    .icon-box { width: 45px; height: 45px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; margin-right: 15px; }
                    .card-label { color: #8c8c8c; font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
                    .card-value { font-size: 1.25rem; font-weight: 700; color: #323a45; }
                    .card-subtext { font-size: 0.65rem; color: #bababa; margin-top: 2px; }
                    .filter-card { background: #fff; border-radius: 12px; border: none; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05); }
                    .custom-table thead th { background: #f8f9fa; border-top: none; color: #7d7d7d; font-weight: 600; text-transform: uppercase; font-size: 0.7rem; padding: 12px 15px; }
                    .custom-table tbody td { padding: 10px 15px; vertical-align: middle; border-top: 1px solid #f0f0f0; }
                    /* Modales alineados a ListadoDocumentosSoporte (nota anulación / industrial) */
                    .lf-ds-modal .modal-content {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.08) !important;
                        box-shadow: 0 12px 32px rgba(0,0,0,0.08) !important;
                        overflow: hidden;
                    }
                    .lf-ds-modal .modal-header.lf-ds-modal-head {
                        background: #f8f9fa !important;
                        border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                    }
                    .lf-ds-modal .modal-header.lf-ds-modal-head .modal-title {
                        font-size: 1rem;
                        font-weight: 700;
                        color: #323a45;
                    }
                    .lf-ds-modal .modal-header.lf-ds-modal-head .close {
                        color: #323a45;
                        opacity: 0.65;
                        text-shadow: none;
                    }
                    .lf-ds-alert-info-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(23, 162, 184, 0.28);
                        background: rgba(23, 162, 184, 0.09);
                        color: #0c5460;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lf-ds-alert-caution-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(212, 167, 44, 0.35);
                        background: linear-gradient(180deg, #fffdf8 0%, #fff8ec 100%);
                        color: #5c4508;
                        padding: 12px 14px;
                        font-size: 0.875rem;
                    }
                    .lf-ds-alert-success-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(40, 167, 69, 0.28);
                        background: linear-gradient(180deg, #f9fdf9 0%, #eef7f0 100%);
                        color: #1e4d2a;
                        padding: 14px 16px;
                        font-size: 0.9rem;
                    }
                    .lf-ds-alert-danger-soft {
                        border-radius: 12px;
                        border: 1px solid rgba(220, 53, 69, 0.28);
                        background: linear-gradient(180deg, #fffbfb 0%, #fdeff0 100%);
                        color: #721c24;
                        padding: 14px 16px;
                        font-size: 0.9rem;
                    }
                    .lf-ds-dian-detail-panel {
                        border-radius: 12px;
                        border: 1px solid rgba(0,0,0,0.08);
                        background: #fff;
                        padding: 16px 18px;
                        margin-top: 14px;
                    }
                    .lf-ds-dian-detail-panel .lf-dian-label {
                        font-size: 0.68rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.05em;
                        color: #6c757d;
                        margin-bottom: 6px;
                    }
                    .lf-ds-dian-detail-panel .lf-dian-uuid {
                        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Courier New", monospace;
                        font-size: 0.78rem;
                        color: #2c3e50;
                        word-break: break-all;
                        line-height: 1.5;
                        background: #f4f6f8;
                        padding: 10px 12px;
                        border-radius: 8px;
                        border: 1px solid rgba(0,0,0,0.06);
                    }
                    .lf-ds-dian-detail-panel .lf-dian-badge {
                        font-size: 0.8rem;
                        font-weight: 600;
                        padding: 0.35em 0.75em;
                        border-radius: 999px;
                    }
                    .lf-dian-debug-modal .modal-dialog {
                        max-width: min(720px, calc(100vw - 2rem));
                    }
                    .lf-dian-debug-modal.lf-dian-debug-modal--wide .modal-dialog {
                        max-width: min(960px, calc(100vw - 2rem));
                    }
                    /* NC no electrónica: alto máximo y scroll en el cuerpo (footer siempre visible) */
                    .lf-ds-modal.lf-nc-ne-modal .modal-dialog {
                        max-height: calc(100vh - 1rem);
                        margin: 0.5rem auto;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-content {
                        max-height: calc(100vh - 1rem);
                        display: flex;
                        flex-direction: column;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-content > form {
                        display: flex;
                        flex-direction: column;
                        min-height: 0;
                        flex: 1 1 auto;
                        max-height: 100%;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-body {
                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;
                        flex: 1 1 auto;
                        min-height: 0;
                    }
                    .lf-ds-modal.lf-nc-ne-modal .modal-footer {
                        flex-shrink: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Listado de Facturas</li>
                                    </ol>
                                </div>
                            </div>
                            {/* Título de página */}
                            <div className="row mb-2 align-items-center">
                                <div className="col-sm-12">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem' }}>Listado de Facturas</h1>
                                </div>
                            </div>
                            {/* Dashboard Stats */}
                            <div className="row mb-4">
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(23, 162, 184, 0.1)', color: '#17a2b8'}}><i className="fas fa-file-invoice"></i></div>
                                        <div><div className="card-label">Facturas</div><div className="card-value">{totales.conteo}</div><div className="card-subtext">Registros totales</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(40, 167, 69, 0.1)', color: '#28a745'}}><i className="fas fa-dollar-sign"></i></div>
                                        <div><div className="card-label">Total</div><div className="card-value">${Math.round(totales.total).toLocaleString('es-CO')}</div><div className="card-subtext">Venta Bruta</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(0, 123, 255, 0.1)', color: '#007bff'}}><i className="fas fa-cash-register"></i></div>
                                        <div><div className="card-label">Cobrado</div><div className="card-value">${Math.round(totales.recaudado).toLocaleString('es-CO')}</div><div className="card-subtext">{Math.round((totales.recaudado / (totales.total || 1)) * 100)}% recaudado</div></div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="summary-card d-flex align-items-center">
                                        <div className="icon-box" style={{background: 'rgba(255, 193, 7, 0.1)', color: '#ffc107'}}><i className="fas fa-clock"></i></div>
                                        <div><div className="card-label">Pendiente</div><div className="card-value">${Math.round(totales.pendiente).toLocaleString('es-CO')}</div><div className="card-subtext">Cartera activa</div></div>
                                    </div>
                                </div>
                            </div>
                            {/* Filtros */}
                            <div className="filter-card p-4 mb-4">
                                <div className="row">
                                    <div className="col-md-2"><label className="small font-weight-bold">Fecha Inicio</label><input type="date" className="form-control" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} /></div>
                                    <div className="col-md-2"><label className="small font-weight-bold">Fecha Fin</label><input type="date" className="form-control" value={fechaFin} onChange={e => setFechaFin(e.target.value)} /></div>
                                    <div className="col-md-2"><label className="small font-weight-bold">Profesional</label>
                                        <select className="form-control" value={usuarioFiltro} onChange={e => setUsuarioFiltro(e.target.value)}>
                                            <option value="">Todos</option>
                                            {usuarios.map(usuario => (
                                                <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2"><label className="small font-weight-bold">Estado</label>
                                        <select className="form-control" value={estadoFiltro} onChange={e => setEstadoFiltro(e.target.value)}>
                                            <option value="">Todos</option>
                                            <option value="contado">Contado</option>
                                            <option value="credito">Crédito</option>
                                            <option value="pendientes_envio">Pendiente envío</option>
                                            <option value="pendientes_pago">Pendiente pago</option>
                                            <option value="contabilidad">Contabilidad</option>
                                            <option value="3">Anuladas</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2"><label className="small font-weight-bold">Tipo Factura</label>
                                        <select className="form-control" value={tipoFacturaFiltro} onChange={e => setTipoFacturaFiltro(e.target.value)}>
                                            <option value="">Todas</option>
                                            <option value="electronica">Electrónica</option>
                                            <option value="no_electronica">No Electrónica</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2"><label className="small font-weight-bold">Nro. Factura</label><input type="text" className="form-control" placeholder="Nro..." value={numeroFactura} onChange={e => setNumeroFactura(e.target.value)} /></div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4"><label className="small font-weight-bold">Paciente</label><input type="text" className="form-control" placeholder="Buscar por nombre..." value={busquedaPaciente} onChange={e => setBusquedaPaciente(e.target.value)} /></div>
                                    <div className="col-md-4"><label className="small font-weight-bold">Identificación</label><input type="text" className="form-control" placeholder="Cédula, NIT o documento..." value={busquedaDocumento} onChange={e => setBusquedaDocumento(e.target.value)} /></div>
                                    <div className="col-md-4 d-flex align-items-end" style={{ position: 'relative' }}>
                                        <button className="btn btn-primary w-100" style={{ borderRadius: '10px' }} onClick={() => setShowDropdownFactura(!showDropdownFactura)}><i className="fas fa-plus mr-2"></i> Nueva Factura</button>
                                        {showDropdownFactura && (
                                            <div className="dropdown-menu show shadow-lg border-0" style={{ position: 'absolute', top: '100%', right: '0', zIndex: 1000, borderRadius: '12px', minWidth: '200px' }}>
                                                <Link to="/crear-factura" className="dropdown-item py-2"><i className="fas fa-file-invoice-dollar mr-2 text-info"></i> Electrónica (DIAN)</Link>
                                                <Link to="/crear-factura-no-electronica" className="dropdown-item py-2"><i className="fas fa-receipt mr-2 text-secondary"></i> No Electrónica </Link>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* Tabla */}
                            <div className="card shadow-sm border-0" style={{borderRadius: '16px', overflow: 'hidden'}}>
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table custom-table mb-0" style={{minWidth: '1200px'}}>
                                        <thead>
                                            <tr>
                                                <th>N° Factura</th>
                                                <th>Fecha</th>
                                                <th>Paciente</th>
                                                <th>Profesional</th>
                                                <th className="text-right">Total</th>
                                                <th className="text-right">Por Cobrar</th>
                                                <th className="text-center">Tipo</th>
                                                <th className="text-center">DIAN</th>
                                                <th className="text-center">Estado</th>
                                                <th className="text-center" width="80">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {facturasPaginadas.map((f) => {
                                                const est = parseInt(f.estado);
                                                const sal = parseFloat(f.valor_pendiente || 0);
                                                const esNoElectronica = f.tipo_factura === 'no_electronica' || [4, 5].includes(est);
                                                const dianStatus = esNoElectronica ? 'no_aplica' : ([1, 2, 3].includes(est) ? 'enviado' : 'no_enviado');
                                                const dianBadgeStyle = dianStatus === 'enviado'
                                                    ? { background: 'rgba(40, 167, 69, 0.08)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)', borderRadius: '10px' }
                                                    : dianStatus === 'no_aplica'
                                                        ? { background: 'rgba(108, 117, 125, 0.08)', color: '#6c757d', border: '1px solid rgba(108, 117, 125, 0.22)', borderRadius: '10px' }
                                                        : { background: 'rgba(250, 173, 20, 0.10)', color: '#faad14', border: '1px solid rgba(250, 173, 20, 0.22)', borderRadius: '10px' };
                                                return (
                                                    <tr key={f.id}>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span style={{ color: '#17a2b8', fontWeight: 700 }}>#{f.numero_factura || f.id}</span>
                                                                <span style={{ fontSize: '0.65rem', color: '#8c8c8c' }}>{f.fev === 1 ? 'DIAN ELECTRÓNICA' : ''}</span>
                                                            </div>
                                                        </td>
                                                        <td className="text-muted text-center">{formatearFecha(f.fecha_emision)}</td>
                                                        <td><div style={{ fontWeight: 600, color: '#323a45' }}>{getNombrePaciente(f.paciente_id)}</div></td>
                                                        <td style={{ color: '#8c8c8c' }}>{getNombreUsuario(f.users_id)}</td>
                                                        <td className="text-right"><strong>{formatearValor(f.valor_total)}</strong></td>
                                                        <td className="text-right"><strong style={{ color: sal > 0 ? '#faad14' : '#52c41a' }}>{formatearValor(sal)}</strong></td>
                                                        <td className="text-center">
                                                            <span className="badge" style={{ background: esNoElectronica ? 'rgba(108, 117, 125, 0.08)' : 'rgba(23, 162, 184, 0.1)', border: `1px solid ${esNoElectronica ? 'rgba(108, 117, 125, 0.25)' : 'rgba(23, 162, 184, 0.25)'}`, color: esNoElectronica ? '#6c757d' : '#17a2b8' }}>
                                                                <i className={`fas ${esNoElectronica ? 'fa-file-alt' : 'fa-bolt'} mr-1`}></i>
                                                                {esNoElectronica ? 'No electrónica' : 'Electrónica'}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className="badge"
                                                                style={{
                                                                    ...dianBadgeStyle,
                                                                    fontWeight: 700,
                                                                    fontSize: '0.7rem',
                                                                    padding: '6px 10px'
                                                                }}
                                                            >
                                                                {esNoElectronica ? 'NO APLICA' : ([1, 2, 3].includes(est) ? 'ENVIADO' : 'NO ENVIADO')}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className="badge"
                                                                style={{
                                                                    ...getEstadoBadgeStyle(est),
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 700,
                                                                    padding: '6px 10px'
                                                                }}
                                                            >
                                                                {getEstadoTexto(est)}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <button className="btn btn-sm btn-light border" style={{borderRadius: '8px'}} onClick={() => handleAbrirAcciones(f)}><i className="fas fa-ellipsis-v"></i></button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="card-footer bg-white border-0 py-3">
                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                        <div style={{ color: '#8c8c8c', fontSize: '0.8rem', flex: 1 }}>
                                            Mostrando <strong>{indicePrimerRegistro + 1}</strong> a <strong>{Math.min(indiceUltimoRegistro, facturasParaVista.length)}</strong> de <strong>{facturasParaVista.length}</strong> facturas
                                        </div>

                                        {totalPaginas > 1 && (
                                            <nav>
                                                <ul className="pagination pagination-sm mb-0" style={{ gap: '5px' }}>
                                                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link border-0 shadow-sm"
                                                            onClick={() => cambiarPagina(paginaActual - 1)}
                                                            style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}
                                                        >
                                                            <i className="fas fa-chevron-left"></i>
                                                        </button>
                                                    </li>

                                                    {getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                                                        if (item === null) {
                                                            return (
                                                                <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                    <span className="page-link border-0 shadow-sm" style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#8c8c8c' }}>
                                                                        ...
                                                                    </span>
                                                                </li>
                                                            );
                                                        }

                                                        return (
                                                            <li key={item} className={`page-item ${paginaActual === item ? 'active' : ''}`}>
                                                                <button
                                                                    className="page-link border-0 shadow-sm"
                                                                    onClick={() => cambiarPagina(item)}
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        padding: '6px 12px',
                                                                        background: paginaActual === item ? '#17a2b8' : '#f8f9fa',
                                                                        color: paginaActual === item ? 'white' : '#323a45',
                                                                        fontWeight: 700,
                                                                        border: 0
                                                                    }}
                                                                >
                                                                    {item}
                                                                </button>
                                                            </li>
                                                        );
                                                    })}

                                                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link border-0 shadow-sm"
                                                            onClick={() => cambiarPagina(paginaActual + 1)}
                                                            style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}
                                                        >
                                                            <i className="fas fa-chevron-right"></i>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer and Modals */}
                <Footer showToast={false} delay={0} />
                {/* Modal Recibo de Caja */}
                {showModalRecibo && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-dialog-centered shadow-lg">
                            <div className="modal-content border-0" style={{borderRadius: '16px'}}>
                                <div className="modal-header border-0 bg-light">
                                    <h6 className="modal-title font-weight-bold">Registrar Recibo</h6>
                                    <button type="button" className="close" onClick={() => setShowModalRecibo(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-4">
                                    <div className="form-group mb-3">
                                        <label className="small text-muted d-block">Factura / saldo pendiente</label>
                                        <div className="border rounded px-3 py-2 bg-light">
                                            <div className="font-weight-bold">N° {facturaSeleccionada?.numero_factura}</div>
                                            <div className="small text-muted mb-0">
                                                Saldo pendiente (informativo):{' '}
                                                <strong className="text-dark">${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group"><label className="small text-muted">Valor a recibir</label><div className="input-group"><div className="input-group-prepend"><span className="input-group-text" title="Pesos colombianos"><i className="fas fa-dollar-sign" aria-hidden="true"></i></span></div><input type="number" className="form-control" value={valorRecibo} onChange={e => setValorRecibo(e.target.value)} step="0.01" min="0" /></div><small className="text-muted">Máximo: ${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</small></div>
                                    <div className="form-group"><label className="small text-muted">Medio de Pago</label><select className="form-control" value={medioPago} onChange={e => setMedioPago(e.target.value)}><option value="10">Efectivo</option><option value="42">Consignación</option><option value="31">Transferencia Débito</option><option value="48">Tarjeta Crédito</option></select></div>
                                    <div className="form-group"><label className="small text-muted">Fecha Pago</label><input type="date" className="form-control" value={fechaPago} onChange={e => setFechaPago(e.target.value)} /></div>
                                    <div className="form-group"><label className="small text-muted">Observaciones</label><textarea className="form-control" rows="2" value={observacionesRecibo} onChange={e => setObservacionesRecibo(e.target.value)}></textarea></div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button className="btn btn-light" onClick={() => setShowModalRecibo(false)}>Cancelar</button>
                                    <button className="btn btn-info px-4" style={{borderRadius: '10px'}} onClick={guardarRecibo}>Guardar Pago</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* Modal Ver Recibos */}
                {showModalRecibos && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0" style={{borderRadius: '16px'}}>
                                <div className="modal-header border-0 bg-light">
                                    <h6 className="modal-title font-weight-bold">Historial de Pagos - Factura #{facturaSeleccionada?.numero_factura}</h6>
                                    <button type="button" className="close" onClick={() => setShowModalRecibos(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-0">
                                    <table className="table mb-0 small">
                                        <thead className="bg-light"><tr><th>Recibo</th><th>Fecha</th><th className="text-right">Valor</th><th>Estado</th><th>Acciones</th></tr></thead>
                                        <tbody>
                                            {recibosFactura.map(r => (
                                                <tr key={r.id}>
                                                    <td>{r.numero_recibo}</td>
                                                    <td>{formatearFecha(r.fecha_pago)}</td>
                                                    <td className="text-right font-weight-bold">{formatearValor(r.valor_pago)}</td>
                                                    <td><span className={`badge ${r.estado === 0 ? 'badge-danger' : 'badge-success'}`}>{r.estado === 0 ? 'Anulado' : 'Activo'}</span></td>
                                                    <td>
                                                        <button className="btn btn-xs btn-outline-info mr-1" onClick={() => vistaPreviaRecibo(r)}><i className="fas fa-eye"></i></button>
                                                        {r.estado !== 0 && <button className="btn btn-xs btn-outline-danger" onClick={() => anularRecibo(r.id)}><i className="fas fa-ban"></i></button>}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer border-0"><button className="btn btn-light" onClick={() => setShowModalRecibos(false)}>Cerrar</button></div>
                            </div>
                        </div>
                    </div>
                )}
                {/* Action Modal (Centralizado) */}
                {showModalAcciones && facturaAccion && (
                    <div className="modal fade show" style={{display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999}}>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content border-0 shadow-lg" style={{borderRadius: '20px', overflow: 'hidden'}}>
                                <div className="modal-header border-0 pb-0" style={{background: '#f8f9fa'}}>
                                    <h6 className="modal-title font-weight-bold small">
                                        OPCIONES {facturaAccion.numero_factura ? `N° ${facturaAccion.numero_factura}` : `— Borrador #${facturaAccion.id}`}
                                    </h6>
                                    <button type="button" className="close" onClick={() => setShowModalAcciones(false)}><span>&times;</span></button>
                                </div>
                                <div className="modal-body p-3">
                                    <div className="list-group list-group-flush">
                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirInformacionFactura(facturaAccion.id); setShowModalAcciones(false); }} style={{borderRadius: '12px', background: 'rgba(23, 162, 184, 0.05)'}}>
                                            <i className="fas fa-eye mr-2 text-info"></i> Ver factura
                                        </button>
                                        {parseInt(facturaAccion.estado, 10) === 6 && (
                                            <button
                                                type="button"
                                                className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                onClick={() => {
                                                    setShowModalAcciones(false);
                                                    reenviarFacturaDian(facturaAccion.id);
                                                }}
                                                style={{ borderRadius: '12px', background: 'rgba(255, 193, 7, 0.15)' }}
                                            >
                                                <i className="fas fa-redo mr-2 text-warning"></i> Reenviar a la DIAN
                                            </button>
                                        )}
                                        {parseInt(facturaAccion.estado, 10) === 7 && (
                                            <button
                                                className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                onClick={() => {
                                                    abrirCompletarDatos(facturaAccion.id);
                                                    setShowModalAcciones(false);
                                                }}
                                                style={{ borderRadius: '12px', background: 'rgba(40, 167, 69, 0.08)' }}
                                            >
                                                <i className="fas fa-edit mr-2 text-success"></i> Completar datos
                                            </button>
                                        )}
                                        {(facturaAccion.estado === 2 || facturaAccion.estado === 5) && (
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirModalRecibo(facturaAccion); setShowModalAcciones(false); }} style={{borderRadius: '12px'}}>
                                                <i className="fas fa-cash-register mr-2 text-success"></i> Registrar Pago
                                            </button>
                                        )}
                                        {!esFacturaContado(facturaAccion) && (
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { verRecibos(facturaAccion); setShowModalAcciones(false); }} style={{borderRadius: '12px'}}>
                                                <i className="fas fa-history mr-2 text-secondary"></i> Ver Recibos
                                            </button>
                                        )}
                                        {parseInt(facturaAccion.estado, 10) !== 3 && (
                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center text-danger" onClick={() => { abrirFlujoAnularFactura(facturaAccion); setShowModalAcciones(false); }} style={{borderRadius: '12px'}}>
                                                <i className="fas fa-ban mr-2"></i> Anular Factura
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito Electrónica */}
                {showModalNotaCredito && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10050 }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header bg-danger text-white">
                                    <h4 className="modal-title">
                                        <i className="fas fa-file-invoice"></i> Generar Nota Crédito Electrónica
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalNotaCredito(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className={`alert ${esFacturaContado(facturaSeleccionada) ? 'alert-secondary border' : 'alert-info'} mb-3`} style={{ borderRadius: 12 }}>
                                        <strong>Factura:</strong> {facturaSeleccionada?.numero_factura}<br />
                                        <strong>Paciente:</strong> {getNombrePaciente(facturaSeleccionada?.paciente_id)}<br />
                                        {esFacturaContado(facturaSeleccionada) ? (
                                            <>
                                                <strong>Venta de contado:</strong> nota crédito por el <strong>valor total</strong> (${Math.round(getValorTotalNum(facturaSeleccionada)).toLocaleString('es-CO')}) — anulación completa.
                                            </>
                                        ) : (
                                            <>
                                                <strong>Saldo pendiente:</strong> ${Math.round(getSaldoPendienteNum(facturaSeleccionada)).toLocaleString('es-CO')}
                                            </>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo *</label>
                                                <select
                                                    className="form-control"
                                                    value={prefijoSeleccionado}
                                                    onChange={handlePrefijoChange}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {prefijos.map(prefijo => (
                                                        <option key={prefijo.id} value={prefijo.id}>
                                                            {prefijo.prefijo}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota Crédito *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={numeroNotaCredito}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Nota Crédito *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaNotaCredito}
                                                    onChange={(e) => setFechaNotaCredito(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo de Nota Crédito *</label>
                                                <select
                                                    className="form-control"
                                                    value={tipoNotaCredito}
                                                    onChange={(e) => {
                                                        const nuevoTipo = e.target.value;
                                                        setTipoNotaCredito(nuevoTipo);
                                                        if (nuevoTipo === 'total') {
                                                            setValorNotaCredito(getImporteNcTipoTotal(facturaSeleccionada));
                                                        } else {
                                                            setValorNotaCredito('');
                                                        }
                                                    }}
                                                >
                                                    <option value="total">
                                                        {esFacturaContado(facturaSeleccionada)
                                                            ? 'Total (anulación completa — valor de la factura)'
                                                            : 'Total (saldo pendiente completo)'}
                                                    </option>
                                                    {!esFacturaContado(facturaSeleccionada) && (
                                                        <option value="parcial">Parcial (solo facturas a crédito)</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor a Acreditar *</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorNotaCredito}
                                                        onChange={(e) => setValorNotaCredito(e.target.value)}
                                                        readOnly={tipoNotaCredito === 'total'}
                                                        max={esFacturaContado(facturaSeleccionada) ? getValorTotalNum(facturaSeleccionada) : getSaldoPendienteNum(facturaSeleccionada)}
                                                        required
                                                    />
                                                </div>
                                                {tipoNotaCredito === 'parcial' && (
                                                    <small className="form-text text-muted">Indique el valor a acreditar (no mayor al saldo pendiente).</small>
                                                )}
                                                {tipoNotaCredito === 'total' && esFacturaContado(facturaSeleccionada) && (
                                                    <small className="form-text text-info">Se emite por el valor total de la factura (venta de contado).</small>
                                                )}
                                                {tipoNotaCredito === 'total' && !esFacturaContado(facturaSeleccionada) && (
                                                    <small className="form-text text-info">Se acreditará el saldo pendiente completo.</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Motivo *</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={motivoNotaCredito}
                                                    onChange={(e) => setMotivoNotaCredito(e.target.value)}
                                                    placeholder="Describa la razón de la nota crédito..."
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCredito(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-primary" onClick={generarNotaCredito}>
                                        <i className="fas fa-paper-plane"></i> Generar y Enviar a DIAN
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal resultado envío DIAN / vista JSON (estilo alineado a lf-ds-modal) */}
                {showModalDebug && (
                    <div
                        className={`modal fade show lf-ds-modal lf-dian-debug-modal${debugType !== 'success' ? ' lf-dian-debug-modal--wide' : ''}`}
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050 }}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                            <div className="modal-content border-0 shadow">
                                <div className="modal-header lf-ds-modal-head align-items-center">
                                    <h5 className="modal-title mb-0 d-flex align-items-center font-weight-bold">
                                        {debugType === 'success' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(40, 167, 69, 0.12)', color: '#28a745' }}>
                                                <i className="fas fa-check"></i>
                                            </span>
                                        )}
                                        {debugType === 'json' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(23, 162, 184, 0.12)', color: '#17a2b8' }}>
                                                <i className="fas fa-code"></i>
                                            </span>
                                        )}
                                        {debugType !== 'success' && debugType !== 'json' && (
                                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle mr-2" style={{ width: 36, height: 36, background: 'rgba(220, 53, 69, 0.12)', color: '#dc3545' }}>
                                                <i className="fas fa-exclamation"></i>
                                            </span>
                                        )}
                                        {debugType === 'success'
                                            ? 'Envío a la DIAN'
                                            : debugType === 'json'
                                            ? 'Vista previa — JSON'
                                            : 'No se pudo enviar a la DIAN'}
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalDebug(false)} aria-label="Cerrar">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body pt-3 pb-2">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="lf-ds-alert-success-soft mb-0">
                                                <strong className="d-block mb-1">{mensajeClienteSinCodigoEstado(debugData?.message || 'Operación completada.')}</strong>
                                                <span className="text-muted small d-block" style={{ lineHeight: 1.45 }}>
                                                    El proveedor de emisión confirmó el documento. Guarde el CUDE o UUID para sus registros.
                                                </span>
                                            </div>
                                            <div className="lf-ds-dian-detail-panel">
                                                <div className="lf-dian-label">CUDE / UUID</div>
                                                <div className="lf-dian-uuid">{debugData?.uuid || debugData?.cufe || '—'}</div>
                                                {debugData?.numero_nc ? (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label">Nota crédito</div>
                                                        <span className="lf-dian-badge badge badge-success">{debugData.numero_nc}</span>
                                                        {debugData?.recibos_anulados > 0 && (
                                                            <span className="lf-dian-badge badge badge-warning ml-2">Recibos anulados: {debugData.recibos_anulados}</span>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="mt-3">
                                                        <div className="lf-dian-label">Estado en sistema</div>
                                                        <span
                                                            className={`lf-dian-badge badge ${debugData?.estado === 1 ? 'badge-success' : 'badge-info'}`}
                                                        >
                                                            {debugData?.estado === 1 ? 'Cobrada (contado)' : 'Por cobrar (crédito)'}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info"
                                                        onClick={() => {
                                                            const p = getSpaPathPrefix();
                                                            window.location.href = `${window.location.origin}${p}/#/informacion-factura/${debugData.facturaId}`;
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice mr-1"></i> Ver factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : debugType === 'json' && debugData?.json ? (
                                        <pre
                                            className="mb-0"
                                            style={{
                                                backgroundColor: '#f4f6f8',
                                                padding: '14px 16px',
                                                borderRadius: '12px',
                                                maxHeight: 'min(520px, 70vh)',
                                                overflow: 'auto',
                                                fontSize: '12px',
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word',
                                                border: '1px solid rgba(0,0,0,0.06)',
                                                fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace',
                                            }}
                                        >
                                            {JSON.stringify(debugData.json, null, 2)}
                                        </pre>
                                    ) : (
                                        <div>
                                            <div className="lf-ds-alert-danger-soft mb-3">
                                                <strong className="d-block mb-1">Detalle</strong>
                                                <span style={{ lineHeight: 1.5 }}>{mensajeClienteSinCodigoEstado(debugData?.message || 'Ocurrió un error al comunicarse con el servicio de emisión.')}</span>
                                            </div>

                                            {debugData?.response && (
                                                <div className="lf-ds-dian-detail-panel mb-3">
                                                    <div className="lf-dian-label">Respuesta del servicio</div>
                                                    <pre
                                                        className="mb-0"
                                                        style={{
                                                            backgroundColor: '#f4f6f8',
                                                            padding: '12px 14px',
                                                            borderRadius: '8px',
                                                            maxHeight: '280px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            border: '1px solid rgba(0,0,0,0.06)',
                                                            fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace',
                                                        }}
                                                    >
                                                        {JSON.stringify(debugData.response, null, 2)}
                                                    </pre>
                                                </div>
                                            )}

                                            {debugData?.json_enviado && (
                                                <div className="lf-ds-dian-detail-panel mb-0">
                                                    <div className="lf-dian-label">JSON enviado (soporte técnico)</div>
                                                    <pre
                                                        className="mb-0"
                                                        style={{
                                                            backgroundColor: '#f4f6f8',
                                                            padding: '12px 14px',
                                                            borderRadius: '8px',
                                                            maxHeight: '280px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            border: '1px solid rgba(0,0,0,0.06)',
                                                            fontFamily: 'ui-monospace, Menlo, Monaco, Consolas, monospace',
                                                        }}
                                                    >
                                                        {JSON.stringify(debugData.json_enviado, null, 2)}
                                                    </pre>
                                                </div>
                                            )}

                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-info"
                                                        onClick={() => {
                                                            const p = getSpaPathPrefix();
                                                            window.location.href = `${window.location.origin}${p}/#/informacion-factura/${debugData.facturaId}`;
                                                        }}
                                                    >
                                                        <i className="fas fa-file-invoice mr-1"></i> Ver factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer border-top bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito No Electrónica (mismo lenguaje visual que nota anulación en documentos soporte) */}
                {showModalNotaCreditoNE && consecutivoNCNE && (
                    <div className="modal fade show lf-ds-modal lf-nc-ne-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 10050, overflowY: 'auto' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content border-0">
                                <div className="modal-header lf-ds-modal-head">
                                    <h5 className="modal-title mb-0">
                                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                                        Nota crédito — factura no electrónica
                                    </h5>
                                    <button type="button" className="close" onClick={() => setShowModalNotaCreditoNE(false)} aria-label="Cerrar">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={generarNotaCreditoNE}>
                                    <div className="modal-body">
                                        <div className="lf-ds-alert-caution-soft mb-3">
                                            <i className="fas fa-info-circle mr-2 text-warning" style={{ opacity: 0.85 }}></i>
                                            Se registrará la nota crédito en el sistema, se actualizarán saldos y se consumirá el consecutivo de NC no electrónica. No aplica envío a la DIAN.
                                        </div>

                                        <div className="lf-ds-alert-info-soft mb-3">
                                            <strong>Factura:</strong>{' '}
                                            {facturaSeleccionada?.prefijo ? `${facturaSeleccionada.prefijo}-` : ''}{facturaSeleccionada?.numero_factura}
                                            <br />
                                            <strong>Paciente:</strong> {getNombrePaciente(facturaSeleccionada?.paciente_id)}
                                            <br />
                                            {esFacturaContado(facturaSeleccionada) ? (
                                                <>
                                                    <strong>Venta de contado:</strong> nota por el <strong>valor total</strong> (${Math.round(getValorTotalNum(facturaSeleccionada)).toLocaleString('es-CO')}).
                                                </>
                                            ) : (
                                                <>
                                                    <strong>Saldo pendiente:</strong> ${Math.round(getSaldoPendienteNum(facturaSeleccionada)).toLocaleString('es-CO')}
                                                </>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Consecutivo nota crédito</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                readOnly
                                                value={(() => {
                                                    const pr = consecutivoNCNE.prefijo != null && String(consecutivoNCNE.prefijo).trim() !== '' ? String(consecutivoNCNE.prefijo).trim() : null;
                                                    const co = consecutivoNCNE.consecutivo;
                                                    if (pr != null && co != null) return `${pr}-${co}`;
                                                    if (co != null) return String(co);
                                                    return '—';
                                                })()}
                                            />
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Tipo de nota *</label>
                                                    <select
                                                        className="form-control"
                                                        value={esFacturaContado(facturaSeleccionada) ? 'total' : tipoNotaCreditoNE}
                                                        onChange={(e) => {
                                                            const nuevoTipo = e.target.value;
                                                            setTipoNotaCreditoNE(nuevoTipo);
                                                            if (nuevoTipo === 'total') {
                                                                setValorNotaCreditoNE(getImporteNcTipoTotal(facturaSeleccionada));
                                                            } else {
                                                                setValorNotaCreditoNE('');
                                                            }
                                                        }}
                                                        disabled={esFacturaContado(facturaSeleccionada)}
                                                    >
                                                        <option value="total">
                                                            {esFacturaContado(facturaSeleccionada)
                                                                ? 'Total (anulación completa — valor de la factura)'
                                                                : 'Total (saldo pendiente completo)'}
                                                        </option>
                                                        {!esFacturaContado(facturaSeleccionada) && (
                                                            <option value="parcial">Parcial (solo facturas a crédito)</option>
                                                        )}
                                                    </select>
                                                    {esFacturaContado(facturaSeleccionada) && (
                                                        <small className="form-text text-muted">En contado solo aplica nota total.</small>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Fecha emisión *</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={fechaNotaCreditoNE}
                                                        onChange={(e) => setFechaNotaCreditoNE(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Valor a acreditar *</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={valorNotaCreditoNE}
                                                    onChange={(e) => setValorNotaCreditoNE(e.target.value)}
                                                    readOnly={tipoNotaCreditoNE === 'total' || esFacturaContado(facturaSeleccionada)}
                                                    min={0}
                                                    step={1}
                                                    max={esFacturaContado(facturaSeleccionada) ? getValorTotalNum(facturaSeleccionada) : getSaldoPendienteNum(facturaSeleccionada)}
                                                    required
                                                />
                                            </div>
                                            {tipoNotaCreditoNE === 'parcial' && !esFacturaContado(facturaSeleccionada) && (
                                                <small className="form-text text-muted">No mayor al saldo pendiente.</small>
                                            )}
                                        </div>

                                        <div className="form-group mb-0">
                                            <label>Motivo *</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={motivoNotaCreditoNE}
                                                onChange={(e) => setMotivoNotaCreditoNE(e.target.value)}
                                                placeholder="Describa la razón de la nota crédito..."
                                                required
                                            />
                                        </div>

                                        {!esFacturaContado(facturaSeleccionada) && tipoNotaCreditoNE === 'total' && (
                                            <p className="text-muted small mb-0 mt-2">Se acreditará el saldo pendiente completo.</p>
                                        )}
                                    </div>
                                    <div className="modal-footer border-top bg-light">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCreditoNE(false)}>Cancelar</button>
                                        <button type="submit" className="btn btn-info" disabled={loadingNCNE}>
                                            {loadingNCNE ? (
                                                <i className="fas fa-spinner fa-spin mr-1"></i>
                                            ) : (
                                                <i className="fas fa-check mr-1"></i>
                                            )}
                                            Generar nota crédito
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                <CompletarDatosFactura show={showModalCompletarDatos} facturaId={facturaCompletarId} onComplete={handleCompletarDatosSuccess} onCancel={() => setShowModalCompletarDatos(false)} />
            </div>
        );
    }

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    return <Loading />;
}

export default ListadoFacturas;
